import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { FieldTemplateMap } from '../models';

export enum FormTemplateMapActionTypes {
  ToggleFormTemplateMapPageLoading = '[FormTemplateMap] Toggle FormTemplateMap Page Loading',
  ToggleFormTemplateMapActionLoading = '[FormTemplateMap] Toggle FormTemplateMap Action Loading',
  RequestFormTemplateMapPage = '[FormTemplateMap] Request FormTemplateMap Page',
  LoadFormTemplateMapPage = '[FormTemplateMap] Load FormTemplateMap Page',
  CancelFormTemplateMapPage = '[FormTemplateMap] Cancel FormTemplateMap Page',
  CreateFormTemplateMap = '[FormTemplateMap] Create FormTemplateMap',
  CreateFormTemplateMapOnServer = '[FormTemplateMap] Create FormTemplateMap On Server',
  UpdateFormTemplateMap = '[FormTemplateMap] Update FormTemplateMap',
  UpdateFormTemplateMapOnServer = '[FormTemplateMap] Update FormTemplateMap On Server',
  ThrowFormTemplateMapError = '[FormTemplateMap] Throw FormTemplateMap Error',
  ClearFormTemplateMapError = '[FormTemplateMap] Clear FormTemplateMap Error',
}

export class ToggleFormTemplateMapPageLoading implements Action {
  readonly type = FormTemplateMapActionTypes.ToggleFormTemplateMapPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleFormTemplateMapActionLoading implements Action {
  readonly type = FormTemplateMapActionTypes.ToggleFormTemplateMapActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestFormTemplateMapPage implements Action {
  readonly type = FormTemplateMapActionTypes.RequestFormTemplateMapPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadFormTemplateMapPage implements Action {
  readonly type = FormTemplateMapActionTypes.LoadFormTemplateMapPage;

  constructor(
    public payload: {
      formTemplateMaps: FieldTemplateMap[];
      totalCount: number;
      query: QueryParamsModel;
    },
  ) {}
}

export class CancelFormTemplateMapPage implements Action {
  readonly type = FormTemplateMapActionTypes.CancelFormTemplateMapPage;
}

export class CreateFormTemplateMap implements Action {
  readonly type = FormTemplateMapActionTypes.CreateFormTemplateMap;

  constructor(public payload: { formTemplateMap: FieldTemplateMap }) {}
}

export class CreateFormTemplateMapOnServer implements Action {
  readonly type = FormTemplateMapActionTypes.CreateFormTemplateMapOnServer;

  constructor(public payload: { formTemplateMap: FieldTemplateMap }) {}
}

export class UpdateFormTemplateMap implements Action {
  readonly type = FormTemplateMapActionTypes.UpdateFormTemplateMap;

  constructor(public payload: { formTemplateMap: Update<FieldTemplateMap> }) {}
}

export class UpdateFormTemplateMapOnServer implements Action {
  readonly type = FormTemplateMapActionTypes.UpdateFormTemplateMapOnServer;

  constructor(public payload: { formTemplateMap: FieldTemplateMap }) {}
}

export class ThrowFormTemplateMapError implements Action {
  readonly type = FormTemplateMapActionTypes.ThrowFormTemplateMapError;

  constructor(public payload: { error: any }) {}
}

export class ClearFormTemplateMapError implements Action {
  readonly type = FormTemplateMapActionTypes.ClearFormTemplateMapError;
}

export type FormTemplateMapActions =
  | ToggleFormTemplateMapPageLoading
  | ToggleFormTemplateMapActionLoading
  | RequestFormTemplateMapPage
  | LoadFormTemplateMapPage
  | CancelFormTemplateMapPage
  | CreateFormTemplateMap
  | CreateFormTemplateMapOnServer
  | UpdateFormTemplateMap
  | UpdateFormTemplateMapOnServer
  | ThrowFormTemplateMapError
  | ClearFormTemplateMapError;
